import React from "react";
import {
  setDataInLocalStorage,
  removeDataInLocalStorage,
} from "../utils/storage";

export type LifeAreasState = {
  keys: Array<string>; //Selected area keys
  scores: {
    [key: string]: number;
  };
  visions: {
    [key: string]: string;
  };
  blockIds: {
    [key: string]: Array<string>;
  };
};

export const initialLifeAreasState: LifeAreasState = {
  keys: [],
  scores: {},
  visions: {},
  blockIds: {},
};

type LifeAreasAction =
  | { type: "ADD_AREA"; key: string }
  | { type: "REMOVE_AREA"; key: string }
  | { type: "SET_AREA_SCORE"; payload: { key: string; score: number } }
  | { type: "SET_VISION"; payload: { key: string; text: string } }
  | { type: "ADD_BLOCK_TO_AREA"; payload: { areaKey: string; blockId: string } }
  | { type: "SET_DATA"; data: LifeAreasState }
  | { type: "CLEAR_DATA" };

type LifeAreasContextType = {
  lifeAreas: LifeAreasState;
  dispatchLifeAreas: React.Dispatch<LifeAreasAction>;
};

const LifeAreasContext = React.createContext<LifeAreasContextType>({
  lifeAreas: initialLifeAreasState,
  dispatchLifeAreas: () => {},
});

export default LifeAreasContext;

// Actions Reducer

export function lifeAreasReducer(
  state: LifeAreasState,
  action: LifeAreasAction
) {
  switch (action.type) {
    case "ADD_AREA": {
      console.log("ADD_AREA", action.key);
      const { key } = action;
      return {
        ...state,
        keys: [...state.keys, key],
        blockIds: { ...state.blockIds, [key]: [] },
      };
    }
    case "REMOVE_AREA": {
      console.log("REMOVE_AREA", action.key);
      const { key } = action;
      let updatedKeys = [...state.keys];
      // Remove key from the array
      const index = updatedKeys.indexOf(key);
      updatedKeys.splice(index, 1);
      // TODO: Remove BlockIds array? Maybe keep it incase they re-select an area
      return {
        ...state,
        keys: updatedKeys,
      };
    }
    case "SET_AREA_SCORE": {
      console.log("SET_SCORE", action.payload);
      return {
        ...state,
        scores: { ...state.scores, [action.payload.key]: action.payload.score },
      };
    }
    case "SET_VISION": {
      console.log("SET_VISION", action.payload);
      const newState = {
        ...state,
        visions: {
          ...state.visions,
          [action.payload.key]: action.payload.text,
        },
      };
      setDataInLocalStorage("lifeAreas", newState);
      return newState;
    }

    // BLOCKS (habits and activities)
    case "ADD_BLOCK_TO_AREA": {
      console.log("ADD_BLOCK_TO_AREA", action.payload);
      const { areaKey, blockId } = action.payload;
      // Push to the array
      // Check it doesn't already exist
      const includes = state.blockIds[areaKey].includes(blockId);
      if (includes) return state;

      let areaBlockIds = [...state.blockIds[areaKey]];
      areaBlockIds.push(blockId);

      const newState = {
        ...state,
        blockIds: {
          ...state.blockIds,
          [areaKey]: areaBlockIds,
        },
      };
      console.log("ADD_BLOCK_TO_AREA new state:", newState);
      setDataInLocalStorage("lifeAreas", newState);
      return newState;
    }

    // case "REMOVE_BLOCK_FROM_AREA": {
    //   console.log("REMOVE_BLOCK_FROM_AREA", action.payload);

    //   // Push to the array
    //   let blockIds = state.blocks[action.]

    //   const newState = {
    //     ...state,
    //     blocks: {
    //       ...state.blocks,
    //       [action.payload.areaKey]: action.payload.text,
    //     },
    //   };
    //   setDataInLocalStorage("lifeAreas", JSON.stringify(newState));
    //   return newState;
    // }
    case "SET_DATA": {
      console.log("SET_DATA", action.data);
      return action.data;
    }
    case "CLEAR_DATA": {
      console.log("CLEAR_DATA LifeAreas");
      removeDataInLocalStorage("lifeAreas");
      return initialLifeAreasState;
    }
    default:
      return state;
  }
}

// export const initialLifeAreasState: LifeAreasState = {
//   keys: ["business", "family", "friendships"],
//   scores: {
//     business: 4.7,
//     family: 6.4,
//     friendships: 7.5,
//   },
//   visions: {
//     business:
//       "My business is making a positive impact to thousands of lives. I can work whenever and wherever I choose.",
//     // family: 'I dont'
//   },
//    blocks: { business: ['blockId', 'blockId2'] }
// };
